import React from "react";
import DisplayData from "./outputs/display-data";

export default function Outputs({ outputs }) {
  return (
    <div>
      {outputs.map((output) => (
        <Item key={output.id} value={output.value} flag={output.flag} />
      ))}
    </div>
  );
}

function _Item({ value, flag }) {
  const className = `output-box ${flag}`;
  return (
    <div className={className}>
        <DisplayData value={value} flag={flag} />
    </div>
  );
}

const Item = React.memo(_Item)